import { Col, Text } from 'components';
import { formatText, theme } from 'lib';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const LinkText = styled.span`
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
  color: ${theme.DARK_BLUE};
  cursor: pointer;
`;

const ReadMoreText = styled.span`
  font-size: 14px;
  line-height: 18px;
  font-weight: 700;
  color: ${theme.GREY_60};
  cursor: pointer;
  ${(props) => !props.showMore && 'position: absolute;'}
  right: 0;
  bottom: 0;
  background-color: #fff;
  padding 4px 0 0 4px;
`;

const NormalText = styled.span`
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
  color: #000;
`;

const Caption = ({ post = {}, handleTagClick, handleClose }) => {
  const [showMore, setShowMore] = useState(false),
    navigate = useNavigate(),
    dispatch = useDispatch(),
    { t } = useTranslation(),
    { caption, owner, calculatedText = '' } = post,
    hasReadMore = caption !== calculatedText;

  function handleTagClick(text, type) {
    if (!showMore) return setShowMore(true);

    switch (type) {
      case 'mention':
        handleClose && handleClose();
        return navigate(`/profile/${text.slice(1)}`);

      case 'tag':
        handleClose && handleClose();
        return navigate(`/posts/${text.replace('#', '')}`, { replace: true });

      case 'url':
        window.open(text, '_blank', 'noreferrer');
    }
  }

  function isText(text) {
    if (text.type === 'mention') {
      const value = post?.mentioned?.find((x) => x.username === text.text.slice(1));

      return value && value !== -1;
    }

    return ['mention', 'tag', 'url'].includes(text.type);
  }

  // Replace the \n's in the text with <br /> tags
  function handleLineBreaks(text) {
    const splitText = text.split('\n');

    return (
      <React.Fragment>
        {splitText.map((x, i) => (
          <React.Fragment key={i}>
            {x}
            {i !== splitText.length - 1 && <br />}
          </React.Fragment>
        ))}
      </React.Fragment>
    );
  }

  if (!caption) return null;

  return (
    <Col marg="0 0 16px" noFlex wid="100%">
      {/* <Clickable
        onClick={() => {
          navigate(`/profile/${owner.username}`);
          handleClose();
        }}>
      {showTime ? (
          <Row center pad='24px 0' borderBottom={`1px solid ${theme.GREY_20}`}>
            <Avatar user={owner} small />

            <Col marg='0 0 0 8px' center gap='2px'>
              <Text b2 bold>
                {owner.name}
              </Text>

              <Text c1 med col={theme.GREY_60}>
                {normalizeDate(post.createdAt, 'Default', t)}
              </Text>
            </Col>
          </Row>
        ) : (
          <Row center start>
            <Avatar user={owner} small />

            <Text b2 bold marg='0 0 0 8px'>
              {owner.name}
            </Text>
          </Row>
        )}
      </Clickable>  */}

      <Col wid="100%" pos="relative">
        <Text marg="8px 0 0 0" wordBreak="break-word">
          {formatText(showMore ? caption : calculatedText).map((x, i) =>
            isText(x) ? (
              <LinkText key={i} onClick={() => handleTagClick(x.text, x.type)}>
                {x.text}
              </LinkText>
            ) : (
              <NormalText key={i}>{handleLineBreaks(x.text)}</NormalText>
            )
          )}{' '}
          {hasReadMore && (
            <ReadMoreText onClick={() => setShowMore(!showMore)} showMore={showMore}>
              {` ... ${t(showMore ? 'common.less' : 'common.more')}`}
            </ReadMoreText>
          )}
        </Text>
      </Col>
    </Col>
  );
};

export default Caption;
